export const OFLC_REVOKE_INVITATION = 'OFLC_REVOKE_INVITATION';
export const OFLC_REVOKE_INVITATION_SUCCESS = 'OFLC_REVOKE_INVITATION_SUCCESS';
export const OFLC_REVOKE_INVITATION_FAILED = 'OFLC_REVOKE_INVITATION_FAILED';

export function revokeInvitation(payload) {
	return {
		type: OFLC_REVOKE_INVITATION,
		payload
	};
}

export function revokeInvitationSuccess(payload) {
	return {
		type: OFLC_REVOKE_INVITATION_SUCCESS,
		payload: payload
	};
}

export function revokeInvitationFail(payload) {
	return {
		type: OFLC_REVOKE_INVITATION_FAILED,
		payload: payload
	};
}
